// extracted by mini-css-extract-plugin
module.exports = {"SVGContainer":"SmallPostsView_SVGContainer__9JpJW"};